<template>
<div class="profile_wrap">
   <div class="side_profile">
     <div class="navigation">
  <ul>
     <li class="list active">
      <router-link exact  :to="{ path: '/Profile/user'}">
        <span class="icon">
         <ion-icon name="person-circle-outline"></ion-icon>
        </span>
        <span class="title">{{get_local_string.string_41}}</span>  
      </router-link>
    </li>
    <li class="list ">
      <router-link  :to="{ path: '/Profile/order'}">
        <span class="icon">
        <ion-icon name="pizza-outline"></ion-icon>
        </span>
        <span class="title">{{get_local_string.string_42}}</span>  
      </router-link>
    </li>
    <li class="list ">
      <router-link  :to="{ path: '/Profile/address'}">
        <span class="icon">
       <ion-icon name="location-outline"></ion-icon>
        </span>
        <span class="title">{{get_local_string.string_43}}</span>  
      </router-link>
    </li>
     <li class="list ">
       <router-link  :to="{ path: '/Profile/mobile'}">
        <span class="icon">
       <ion-icon name="call-outline"></ion-icon>
        </span>
        <span class="title">{{get_local_string.string_44}}</span>  
       </router-link>
    </li>
    <li class="list">
      <router-link  :to="{ path: '/Profile/password'}">
        <span class="icon">
        <ion-icon name="lock-closed-outline"></ion-icon>
        </span>
        <span class="title">{{get_local_string.string_45}}</span>  
      </router-link>
    </li>
     <li class="list">
       <router-link  :to="{ path: '/Profile/coupon'}">
        <span class="icon">
      <ion-icon name="pricetags-outline"></ion-icon>
        </span>
        <span class="title">{{get_local_string.string_46}}</span>  
       </router-link>
    </li>
      <li class="list">
       <router-link  :to="{ path: '/Profile/deactivate-account'}">
        <span class="icon">
      <ion-icon name="person-remove-outline"></ion-icon>
        </span>
        <span class="title">{{get_local_string.string_124}}</span>  
       </router-link>
    </li>
    <li class="" >
      <a @click.prevent="signOut()">
        <span class="icon">
        <ion-icon name="log-out-outline"></ion-icon>
        </span>
        <span class="title">{{get_local_string.string_47}}</span>  
      </a>
    </li>
  </ul> 
      </div>
   </div>
   <div class="side_prodile_content">
        <router-view></router-view>
   </div>

   <!-- {{user}} -->
</div>
</template>

<script>
import $ from 'jquery'
import {mapActions, mapGetters} from 'vuex';
export default {
   name:'profileApp',
   computed:{
    ...mapGetters({
        user:'auth/user',
          get_local_string:'get_local_string'
    })
   },
   methods:{
      ...mapActions({
          signOutAction :'auth/signOut'
      }),
      signOut(){
            this.signOutAction().then(()=>{
                this.$router.replace({
                    name:'Login'
                })
            })
        },
      reduce_side(){
      const list = document.querySelectorAll('.list');
      $('.list').find('.router-link-active').parents('.list').addClass('router-link-active');
      function activeLink(){
      list.forEach((item)=>{
        //router-link-active 
        // console.log(item.querySelector('.router-link-active').parentElement())
        item.classList.remove('router-link-active');
       $(item).find('.router-link-active').parents('.list').addClass('router-link-active')
      })
      this.classList.add('router-link-active');
      }
      list.forEach((item)=> item.addEventListener('click',activeLink))
      }
   },
   mounted(){
      this.reduce_side()
   }
}
</script>
<style lang="scss">
.side_prodile_content{
   width: calc(100% - 300px);
    margin-left: auto;
    padding-left: 30px;
    padding-right: 30px;
}
table tbody tr{
  cursor: pointer;
}
@media screen and (max-width: 992px)
{
.b-table .table-wrapper.has-mobile-cards tr {
    -webkit-box-shadow: 0 2px 3px rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 10%);
    box-shadow: 0 2px 3px rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 10%);
    max-width: 100%;
    position: relative;
    display: block;
}
.b-table .table-wrapper.has-mobile-cards tr:not([class*=is-]) {
    background: var(--active_color) !important;
}
.b-table .table-wrapper.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: auto;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    text-align: right;
    border-bottom: 1px solid whitesmoke;
}
.b-table .table-wrapper.has-mobile-cards thead tr th {
    display: none;
}
.b-table .table-wrapper.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td:before {
    content: attr(data-label);
    font-weight: 600;
    padding-right: 0.5em;
    text-align: left;
}
}
// .container{
//    max-width: 100% !important;
//    padding: 0 !important;
// }
</style>
<style lang="scss" scoped>
.profile_wrap{
   padding-top: 60px;
   min-height: 100vh;
   color: #fff;

   .navigation{
    position: absolute;
    height: 500px;
   //  width: 70px;
       width: 300px;
    background: #1c0a00;
    box-shadow: 10px 0 0 var(--active_color);
    border-left: 10px solid #2a2a2a;
    overflow-x: hidden;
    transition: width 0.5s;
    left: -8px;
    top: 75px;
    height: calc(100vh - 75px);
//   &:hover{
//     width:300px;
//   }
  ul{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    padding-left:5px;
    padding-top:40px;
    
    li{
      position:relative;
      list-style:none;
      width:100%;
      border-radius: 20px 0 0 20px;
      
      
      &.router-link-active{
        background:var(--active_color);
         .title{
            color: black;
         a{
           color: black !important;;
         }
         }
        a::before{
          content:'';
          position: absolute;
          top:-30px;
          right:0;
          width:30px;
          height:30px;
          border-radius:50%;
          box-shadow: 15px 15px 0px var(--active_color);
        }
        a::after{
          content:'';
          position: absolute;
          bottom:-30px;
          right:0;
          width:30px;
          height:30px;
          border-radius:50%;
         box-shadow: 15px -15px 0px var(--active_color);
        }
        
      }
      
      a{
        position:relative;
        display:flex;
        text-decoration:none;
        width:100%;
        align-items: center;
        color:#000;
        
        .icon{
         position: relative;
         display: block;
         min-width: 60px;
         margin-top: -2px;
         text-align: center;
         
          ion-icon{
            position:relative;
            font-size:1.5em;
            z-index:1;
          }
         
          
        }
         
        .title{
            position:relative;
          display:block;
          padding-left:10px;
          height:60px;
            line-height:60px;
            white-space:nowrap;
            color: #fff;
            font-size: 18px;
          }
          .icon{
            color: white;
          }
      }
    }
  }
}
}

@media(max-width:992px){
   .navigation{
     width: 70px !important;
   }
   .side_prodile_content {
    width: calc(100% - 77px) !important;
    margin-left: auto !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
}

}
@media(max-width:767px){
     .side_prodile_content {
    padding-left: 10px !important;
    padding-right: 10px !important;
}
}
</style>